import graphql from 'babel-plugin-relay/macro';
import {useParams} from 'react-router-dom';
import useQuery from '../../components/hooks/useQuery';
import React, {useEffect, useState} from 'react';
import {useMutation} from 'react-relay';
import StartContainer from '../../components/layout/StartContainer';
import Spinner from '../../components/Spinner';

const refreshTokenMutation = graphql`
    mutation LoginWithTokenMutation($accessToken: String!){
        refreshAccessToken(accessToken: $accessToken){
            ...on AccessToken{
                accessToken
            }
            ...on Error{
                code
                message
            }
        }
    }
`


export default function LoginWithToken(props){
    const [error, setError] = useState(null)
    const q = useQuery();
    const [commit] = useMutation(refreshTokenMutation);
    const params = useParams()
    useEffect(()=>{
        if(params.accessToken){
            commit({
                variables:{
                    accessToken: params.accessToken
                },
                onCompleted({refreshAccessToken}){
                    if(refreshAccessToken.accessToken){
                        localStorage.setItem('access_token', refreshAccessToken.accessToken);
                        if(q.redirect_to){
                            window.location = q.redirect_to;
                        }else {
                            window.location = "/"
                        }
                    }else{
                        setError('Invalid token');
                        //history.replace('/auth/login?'+ new URLSearchParams({redirect_to: q.redirect_to || ''}))
                    }
                }
            })

        }
    },[params.accessToken])

    return (
        <StartContainer>
            <div className="text-center" style={{paddingTop:100}}>
                {
                    error ? <p className="text-danger">{error}</p> :
                        <Spinner/>
                }
            </div>
        </StartContainer>
    )
}
